import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Section2 } from "./components/Section2";
import { YachtTypesSection } from "./components/YachtTypesSection";
import { AfterParty } from "./components/AfterParty";
import { HighlightGallery } from "./components/HighlightGallery";
// import { ReadySail } from "./components/ReadySail";
import { SponsorSection } from "./components/SponsorSection";
import Footer from "./components/Footer";
import { MainStage } from "./components/MainStage";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState(JsonData);
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} marqueeLogos={landingPageData.MarqueeLogos ?? []} />
      <Section2 data={landingPageData?.Section2} />
      <MainStage
        data={landingPageData?.MainStage}
        onBook={() => console.log("Book clicked")}
      />
      <YachtTypesSection data={landingPageData?.YachtTypes} />
      <AfterParty />
      <HighlightGallery photos={landingPageData?.HighlightGallery} />
      {/* <ReadySail /> */}
      <SponsorSection groups={landingPageData?.SponsorSection?.groups} />
      <Footer
        socialLinks={{
          facebook: "https://www.facebook.com/profile.php?id=61586176636364",
          instagram: "https://www.instagram.com/theyachtparty.th",
          youtube: "https://youtube.com/...",
        }}
      />
    </div>
  );
};

export default App;
